export default {
    "AnnualSales":"Annual Sales",
    "Company_Self_Reported__c":"Company",
    "department":"Department",
    "Industry_Self_Reported__c":"Industry",
    "address2":"Address Line 2",
    "Address3":"Address Line 3",
    "city":"City",
    "title":"ClienteleTitle",
    "country":"Country",
    "email":"Work email",
    "firstName":"First name",
    "lastName":"Last name",
    "phone":"Phone number",
    "mobilePhone":"Mobile Phone",
    "postalCode":"Zip/Postal code",
    "salutation":"Salutation",
    "state":"State/Province",
    "address":"Address",
    "Job_Title__c":"Job title",
    "Answer_1__c":"Answer 1",
    "Answer_2__c":"Answer 2",
    "Answer_3__c":"Answer 3",
    "Answer_4__c":"Answer 4",
    "Answer_5__c":"Answer 5",
    "Comments_6__c":"Comments 6",
    "Comments_7__c":"Comments 7",
    "Question_1__c":"Question 1",
    "Question_2__c":"Question 2",
    "Question_3__c":"Question 3",
    "Question_4__c":"Question 4",
    "Question_5__c":"Question 5",
    "Challenge__c":"Challenge",
    "Project_Budget__c":"Project budget",
    "Primary_Product_Interest__c":"Product interest (Hold CTRL to select more than one choice)",
    "Purchase_Timeframe__c":"Purchase time frame",
    "Email_Blast_OK__c":"May we send you emails?",
    "Direct_Mail_OK__c":"May we contact you by mail?",
    "OK_to_Call__c":"May we call you by phone?",
    "Preferred_Language__c":"Preffered language",
    "Sales_Contact_Requested__c":"Have a Sales Person contact me"
}